import AppInfoModelBase from '../_generated/modelBases/app-info-model-base';

export default class AppInfoModel extends AppInfoModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
